import { declOfNum } from '../../../../../helpers/dspx-utils';

export const createHouseNumber = (house) => {
  const { building, corpus } = house;
  const corpusText = corpus ? `к. ${corpus}` : undefined;
  return [building, corpusText].filter(Boolean).join(', ');
};

export const createHouseAddress = (house) => {
  return [house.streetName, createHouseNumber(house)]
    .filter(Boolean)
    .join(', ');
};

export const createRoomAddress = (room) => {
  const roomNumber = `${room.typeName} ${room.flat}`;
  return `${createHouseAddress(room)}, ${roomNumber}`;
};

export const getHouseType = (house) =>
  house?.typeName ? `(${house.typeName})` : undefined;

export const createRoomLabelByCount = (roomCount) => {
  return `${roomCount} ${declOfNum(roomCount, [
    'помещение',
    'помещения',
    'помещений',
  ])}`;
};

export const roomsMapToArray = (map) => {
  return [...map.values()].reduce((acc, { name, rooms }) => {
    const obj = { name, rooms: [...rooms.values()] };
    acc.push(obj);
    return acc;
  }, []);
};

export const extractNumbersFromStrings = (strings) => {
  if (!Array.isArray(strings)) return [];

  return [
    ...new Set(
      strings.map((str) => {
        const digit = str.replace(/\D+/g, '');
        return digit ? Number(digit) : null;
      })
    ),
  ]
    .filter(Boolean)
    .sort((a, b) => a - b);
};

export const createRoomRanges = (nums) => {
  if (!Array.isArray(nums) || nums.length === 0) return '';

  const result = [];
  let start = nums[0];

  for (let i = 1; i <= nums.length; i++) {
    if (nums[i] - nums[i - 1] === 1) continue;

    const end = nums[i - 1];

    if (start === end) {
      // одиночное число
      result.push(`${start}`);
    } else if (end - start === 1) {
      // ровно два числа → выводим отдельно
      result.push(`${start}`, `${end}`);
    } else {
      // диапазон из 3+ чисел
      result.push(`${start}-${end}`);
    }

    start = nums[i];
  }

  return result.join(', ');
};

export const roomsArrToObjWithRelations = (rooms) => {
  if (!rooms) return undefined;

  const [mainRoom, ...restRooms] = rooms;

  const result = roomAdapter(mainRoom);

  if (restRooms.length) {
    result.relatedFlats = restRooms.map(roomAdapter);
  }

  return result;
};

function roomAdapter(room) {
  const { addressId, id, ...rest } = room;
  return { ...rest, id: id ?? addressId };
}
